import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import store from "../src/services/redux/store";
// Temporarily remove ChakraProvider to avoid runtime errors caused by theme/provider mismatch.
// We'll run the app without Chakra until the package mismatch is resolved.
import { LoaderProvider } from './context/LoaderContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <LoaderProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </LoaderProvider>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
